import React from 'react';
import ReactDOM from 'react-dom/client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import WebFont from 'webfontloader';

import { queryClient } from './app/queryClient';
import './i18n';
import './index.css';
import Home from './pages/Home';
import reportWebVitals from './reportWebVitals';

WebFont.load({
    google: {
        families: ['Roboto:300,400,500,700', 'Material Icons'],
    },
});

const container = document.getElementById('root');
if (!container) throw new Error('Cannot mount: no #root element in the document');

const root = ReactDOM.createRoot(container);
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Home />
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
